import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  ActiveConfig,
  BaseWidgetProperties,
  ProjectIcon,
  iconSetMaterial,
  iconSetMaterialBold,
  iconSetMisc,
  iconSetPrimeNg,
} from '@finxone-platform/shared/sys-config-types';
import { Subject, takeUntil } from 'rxjs';
import { ActiveConfigService } from '../../../libs/services/active-config/active-config.service';
import { ProjectIconsService } from '../../../libs/services/project-icons/project-icons-service.service';
import { WorkflowCommonService } from '../../../libs/services/workflow-config/workflow.common.service';

@Component({
  standalone: false,
  selector: 'finxone-workflow-frontend-icon-library',
  templateUrl: './icon-library.component.html',
  styleUrls: ['./icon-library.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IconLibraryComponent implements OnInit, OnChanges {
  @Input() baseWidgetProperties: BaseWidgetProperties;
  @Input() uniqueId: string;
  @Input() showLabel: boolean;
  @Output() selectedIconChange = new EventEmitter<string>();
  @Output() changeIconWithBaseProperties = new EventEmitter<BaseWidgetProperties>();
  @Input() selectedIcon: string | null = null;
  @Input() labelText = 'Add/Replace Icon';
  @Input() hideTitleIcon = false;
  public iconSets = [
    {
      header: 'PrimeNg',
      icons: iconSetPrimeNg,
    },
    {
      header: 'Material Bold',
      icons: iconSetMaterialBold,
    },
    {
      header: 'Material',
      icons: iconSetMaterial,
    },
    {
      header: 'Misc',
      icons: iconSetMisc,
    },
  ];
  public projectIcons: ProjectIcon[];

  icons: string[] = []; // TODO: needs deleting and search functionality moving to iconSets
  filteredIcons: string[] = this.icons;
  showLib = false;
  @AutoDestroy private destroy$: Subject<void> = new Subject<void>();
  private activeConfig: ActiveConfig;
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private workflowCommonService: WorkflowCommonService,
    private activeConfigService: ActiveConfigService,
    public projectIconsService: ProjectIconsService,
  ) {}

  ngOnInit(): void {
    if (this.baseWidgetProperties !== undefined) {
      this.selectedIcon = this.baseWidgetProperties.icon ?? '';
    }
    this.activeConfigService
      .getConfig()
      .pipe(takeUntil(this.destroy$))
      .subscribe((activeConfig: ActiveConfig) => {
        this.activeConfig = activeConfig;
      });
    this.projectIconsService.projectIconsList$.pipe(takeUntil(this.destroy$)).subscribe((list) => {
      this.projectIcons = list;
    });
  }

  ngOnChanges(): void {
    if (this.baseWidgetProperties !== undefined && this.baseWidgetProperties.icon != this.selectedIcon) {
      this.selectedIcon = this.baseWidgetProperties.icon ?? '';
    }
  }

  onSearch(value: any) {
    this.filteredIcons = this.icons.filter((icon) => icon.includes(value.target.value));
  }

  public selectIcon(icon: string): void {
    this.selectedIcon = icon;
    this.showLib = false;
    this.selectedIconChange.emit(this.selectedIcon);
    if (this.baseWidgetProperties !== undefined) {
      this.baseWidgetProperties.icon = this.selectedIcon;
      this.updateWorkflowConfig();
    }
  }

  removeIcon(): void {
    this.selectedIcon = '';
    this.selectedIconChange.emit(this.selectedIcon);
    this.showLib = false;
    if (this.baseWidgetProperties !== undefined) {
      this.baseWidgetProperties.icon = this.selectedIcon;
      this.updateWorkflowConfig();
    }
  }

  showLibrary(flag: boolean): void {
    this.showLib = flag;
  }

  updateWorkflowConfig() {
    this.changeIconWithBaseProperties.emit(this.baseWidgetProperties);
    this.workflowCommonService.updateWidgetProperties({
      uniqueId: this.uniqueId,
      widgetProperties: this.baseWidgetProperties,
      isReset: false,
    });
  }
}
